module.exports = __webpack_public_path__ + "static/media/profile.a5d89f85.jpg";